type FlowFunction<P> = (param: P) => P;

/**
 * ç±»ä¼¼ lodash.flow çæ¹æ³
 * @param flows
 */
export function flow<P>(...flows: FlowFunction<P>[]): FlowFunction<P> {
  return (param: P) => {
    return flows.reduce((result: P, f: FlowFunction<P>) => {
      return f(result);
    }, param);
  };
}
